// extracted by mini-css-extract-plugin
export default {"wrapper":"S9-z","boldPrefix":"T9-z","link":"U9-z","message":"V9-z","image":"W9-z"};